import { ProfileContent } from './ProfileContent.component';
import { useCurrentUser } from 'contexts';

export const Profile: React.FC = () => {
  const currentUser = useCurrentUser();

  return <ProfileContent user={currentUser} />;
};